/* Built In Imports */
import { useContext } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';
// import HealthCommonUI from '@components/UI/Health/HealthCommonUI';
import SectionTitle from '@components/Headings/SectionTitle';
import ContentArea from '@components/Layout/ContentArea';
import { AuthContext } from '@store/auth-context';
import HealthChatBot from '@components/Utility/HealthChatBot';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/healthService';

/* Styles */

/**
 *
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Selected Health Micro Category Page Data
 */
const HealthMicroCategoryPage = ({ region, language, pageData }) => {
  const authContext = useContext(AuthContext);

  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url=""
        region={authContext.region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      {/* 0 15px */}
      <Box
        as="section"
        className="page-wrap container-article"
        padding={{ base: '15px', md: '0' }}
      >
        {pageData.body && pageData.body.length
          ? pageData.body.map((section, i) => {
              return (
                <Box as="div" key={i} display="block" placeContent="center">
                  {section?.sectionContent && section?.sectionContent?.length
                    ? section?.sectionContent?.map((secCon, i) => {
                        switch (secCon._modelApiKey) {
                          case 'section_title':
                            return (
                              <Box
                                p={'0 15px'}
                                display={'grid'}
                                placeItems={'center'}
                              >
                                <Box
                                  w={{
                                    xl: '66.66666667%;',
                                    lg: '90%',
                                    md: '90%',
                                    sm: '100%',
                                  }}
                                >
                                  <Box
                                    as={'h1'}
                                    p={{
                                      xl: '2vw 0 0.5vw 0',
                                      sm: 0,
                                      md: 0,
                                      lg: 0,
                                    }}
                                    textAlign={'center'}
                                    m={'0 15px 10px 15px'}
                                    lineHeight="1.13"
                                    // pb="30px"
                                  >
                                    {' '}
                                    <SectionTitle titleObj={secCon} />
                                  </Box>
                                </Box>
                              </Box>
                            );
                          case 'structured_text':
                            return (
                              <Box
                                className="doc-page"
                                lineHeight={'1.61'}
                                pb="30px"
                                color="#28231e"
                                fontSize={{ xl: '18px', sm: '16px' }}
                                opacity={'0.99'}
                              >
                                <ContentArea
                                  mainContent={secCon.body}
                                  region={authContext.region}
                                  lang={language}
                                />
                              </Box>
                            );
                        }
                      })
                    : null}
                </Box>
              );
            })
          : null}
      </Box>
      {config?.ENV_NAME !== 'production' && <HealthChatBot />}
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const healthLandingPaths = config.USE_LOCAL_URL
    ? [
        `/en/health/isha-health-solutions/online-medicine-sales/terms-and-conditions`,
      ]
    : await getLandingPaths('L3', '/health/');
  return {
    paths: healthLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, category, subCat, microCat },
  req,
}) => {
  const language = region;
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale('', language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('', language),
    'iso_non_regional_menu'
  );
  const footerData = await fetchFooterData(
    getLocale('', language),
    'isofooter'
  );
  const pageData = await fetchDetails(
    '',
    language,
    `${category}/${subCat}/${microCat}`,
    { preview, data: previewData }
  );

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: '',
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      category: category,
      subCat: subCat,
      microCat: microCat,
      isPreview: preview ? true : false,
    },
  };
};

export default HealthMicroCategoryPage;
